"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HelpingPetsLiveHealthierHappierLives() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const words = [{
    text: "HEALTHIER,",
    italic: false,
    accent: false
  }, {
    text: "HAPPIER",
    italic: false,
    accent: false
  }, {
    text: "PETS.",
    italic: true,
    accent: true
  }];
  return <section data-section-id="4596" id="helping-pets-live-healthier-happier-lives" className="bg-background text-foreground relative overflow-hidden min-h-[800px] h-screen w-full">
      {}
      <div className="relative grid grid-cols-1 lg:grid-cols-12 h-full w-full">
        {}
        <div ref={leftRef} className="lg:col-span-5 relative z-20 flex flex-col justify-center px-6 sm:px-10 lg:px-14 py-20 lg:py-0">
          {}
          

          {}
          <h1 className="font-default font-bold leading-[0.9] mb-8" style={{
          fontSize: "clamp(2.71rem, 6.32vw, 6.32rem)",
          letterSpacing: "-0.05em"
        }}>
            {words.map((w, i) => <span key={i} data-index={i} className={`block overflow-hidden transition-all duration-1000 ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[110%]"} ${w.italic ? "font-serif italic font-medium" : ""}`} style={{
            transitionDelay: `${200 + i * 150}ms`,
            color: w.accent ? "var(--primary)" : undefined
          }}>
                {w.text}
              </span>)}
          </h1>

          {}
          <p className={`font-serif font-light text-[1.25rem] leading-relaxed max-w-[38ch] mb-10 text-muted-foreground transition-all duration-700 delay-700 ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Simple guides, trackers, and pet wellness tips for dog and cat owners who want to support a healthy weight.
          </p>

          {}
          <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-[900ms] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Link to="/StartHerePage">
              <Button size="lg" className="h-12 px-7 font-mono text-xs tracking-[0.18em] font-medium shadow-lg hover:opacity-90 rounded-lg" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }}>
                START HERE →
              </Button>
            </Link>
            <Button variant="ghost" size="lg" className="h-12 px-7 font-mono text-xs tracking-[0.18em] font-medium border border-border hover:bg-secondary rounded-lg">
              <Play className="size-3 fill-current" />
              DOWNLOAD TRACKER
            </Button>
          </div>

          {}
          <div className={`hidden lg:flex absolute bottom-10 left-14 items-center gap-3 font-mono text-[10px] tracking-[0.3em] text-muted-foreground transition-opacity duration-1000 delay-[1200ms] ${leftVisible ? "opacity-100" : "opacity-0"}`}>
            <span>SCROLL ↓ 01/07</span>
          </div>
        </div>

        {}
        <div ref={rightRef} className="lg:col-span-7 relative overflow-hidden min-h-[400px] lg:min-h-0">
          {}
          <div className="absolute inset-0 overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704107/img/healthy_pet_lifestyle.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704107/img/healthy_pet_lifestyle.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704107/img/healthy_pet_lifestyle.png-wvc-sizes" alt="Happy dog and cat in a bright, modern home environment" loading="lazy" decoding="async" className="w-full h-full object-cover thread-kenburns" style={{
            filter: "saturate(0.85) contrast(1.05)"
          }} />
            {}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: "linear-gradient(90deg, var(--background) 0%, transparent 25%, transparent 75%, hsla(0,0%,0%,0.1) 100%)"
          }} />
          </div>

          {}
          

          {}
        </div>
      </div>

      {}
      <style>{`
        @keyframes thread-kenburns {
          0% { transform: scale(1); }
          100% { transform: scale(1.04); }
        }
        .thread-kenburns {
          animation: thread-kenburns 20s ease-out forwards;
        }
      `}</style>
    </section>;
}